const datePickerStrings = {
  placeholders: {
    date: "Velg dato"
  }
};

export default datePickerStrings;